  function renderDzIndex() {
    /* a designer with nothing standing is not in the register: the client
       retires one from admin and the section follows without a deploy */
    const designers = S.makers.filter(function (m) {
      return m.side === 'selective' && dzWorksOf(m, 1).length;
    });
    /* the stall's window of scroll is cut for the record it actually holds */
    document.body.style.setProperty('--dz-rows', designers.length);
    document.body.dataset.dz = 'micro';
    document.body.dataset.dzmark = 'caret';
    dzAccordion(designers);
  }

  function dzAccordion(designers) {
    const el = document.getElementById('dz-index');
    el.innerHTML = designers.map(function (m, di) {
      const panelId = 'dz-panel-' + m.id;
      /* no price: a figure under every photograph turns the register into a
         price list; the work's own page carries it */
      const strip = dzWorksOf(m, 4).map(function (w, k) {
        return '<a class="dzp-item" style="transition-delay: ' + (140 + k * 110) + 'ms" href="' +
          itemHref(w) + '"><img src="' + w.image + '" alt="' + esc(w.title) +
          '" loading="lazy" decoding="async">' +
          '<span class="dzp-cap">' + esc(w.title) + (w.year ? ', ' + w.year : '') +
          (w.status === 'sold' ? ' · ' + esc(said('status', w.status)) : '') + '</span></a>';
      }).join('');
      /* --dzf is a fraction of the record, not a count, so the entry writing
         finishes however many makers the register holds (register.css dz-write) */
      return '<div class="dz-item" style="--dzi: ' + di + '; --dzf: ' +
        (designers.length > 1 ? (di / (designers.length - 1)).toFixed(4) : 0) + '">' +
        '<button class="dz-row-line" type="button"' +
        ' aria-expanded="false" aria-controls="' + panelId + '">' +
        dzRowHTML(m, di) + '</button>' +
        '<div class="dz-panel" id="' + panelId + '" inert><div class="dz-panel-in">' +
        '<p class="dz-bio">' + esc(m.bio) + '</p>' +
        '<div class="dzp-strip">' + strip + '</div>' +
        profileLink(m) +
        '</div></div></div>';
    /* the micro reading draws no field; the field's controller stands, since
       with no groups every call walks an empty list, the no-op the wiring expects */
    }).join('');

    const groups = el.querySelectorAll('.dzi-group');
    /* the field belongs to the opened row and is lent to the hand: leaving the
       list gives the pieces back rather than emptying the field */
    let held = -1;
    /* auto marks the self-opened surfacing so its pieces skip the blur bloom */
    function field(i, auto) {
      const n = i < 0 ? held : i;
      groups.forEach(function (g, k) {
        g.classList.toggle('on', k === n);
        g.classList.toggle('auto', !!auto && k === n);
      });
    }
    /* one controller, so the greeted row holds the field as a clicked one does */
    const fieldCtl = {
      show: field,
      hold: function (i, auto) { held = i; field(i, auto); },
      release: function () { held = -1; field(-1); }
    };
    wireDzField(el, field);

    /* opens the one asked for, -1 shuts all; a closed panel is clipped, not
       removed, inert keeping it out of the tab order */
    function openRow(i) {
      const items = el.querySelectorAll('.dz-item');
      items.forEach(function (o, n) {
        const want = n === i;
        if (o.classList.contains('open') === want) return;
        o.classList.toggle('open', want);
        delete o.dataset.auto;
        o.querySelector('.dz-row-line').setAttribute('aria-expanded', want ? 'true' : 'false');
        if (want) o.querySelector('.dz-panel').removeAttribute('inert');
        else o.querySelector('.dz-panel').setAttribute('inert', '');
      });
    }

    el.querySelectorAll('.dz-row-line').forEach(function (row, ri) {
      row.addEventListener('click', function () {
        const open = row.parentElement.classList.contains('open');
        openRow(open ? -1 : ri);
        if (open) { held = -1; field(ri); } else { fieldCtl.hold(ri); }
      });
    });
    greetRegister(el, fieldCtl);
  }

  /* The register greets with one panel open at render, not on arrival: an
     arrival needs a threshold and a beat fitted to a row count the client can
     change, and a panel already open needs neither and cannot race the sheet.
     The row is drawn so a different name greets each visit; REDUCE and ?shot
     stand it down, so a still is deterministic. */
  function greetRegister(el, fieldCtl) {
    const items = el.querySelectorAll('.dz-item');
    if (!items.length || REDUCE || param('shot')) return;
    const i = Math.floor(Math.random() * items.length);
    const item = items[i];
    item.classList.add('open');
    /* data-auto marks the panel nobody clicked: register.css slows its
       transition and spares its pieces the field's filter */
    item.dataset.auto = '';
    item.querySelector('.dz-row-line').setAttribute('aria-expanded', 'true');
    item.querySelector('.dz-panel').removeAttribute('inert');
    fieldCtl.hold(i, true);
  }

  /* and the footer says when the register is under its sheet, which the register
     cannot see for itself */
  let dzNudgeNow = null;
  function dzNudge(show) {
    if (dzNudgeNow) dzNudgeNow(show);
  }

  /* built here so the landing's markup carries no element only one reading uses */
  function renderRange() {
    const host = document.getElementById('designers');
    if (!host) return;
    const range = document.createElement('div');
    range.className = 'range';
    range.setAttribute('aria-hidden', 'true');
    range.innerHTML = '<span class="rg"></span>';
    host.insertBefore(range, host.firstChild);
  }

/* markup builders: future Liquid */

  function dzWorksOf(m, n) {
    return S.works.filter(function (w) { return w.maker_id === m.id && w.image; }).slice(0, n);
  }
  /* the caret stands rather than waking under the hand: a mark that arrives on
     the pointed row is the target changing */
  function dzMarkHTML() {
    return '<span class="dz-mark">' +
      '<svg class="dzm-caret" viewBox="0 0 10 10" aria-hidden="true">' +
      '<path d="M1 3.2 L5 7 L9 3.2" fill="none" stroke="currentColor" stroke-width="1"/></svg>' +
      '</span>';
  }
  function dzRowHTML(m, di) {
    return '<span class="dz-no">' + String(di + 1).padStart(3, '0') + '</span>' +
      '<span class="dz-name-text maker-name">' + esc(m.name) + '</span>' +
      '<span class="dz-val">' + esc(m.one_liner) + '</span>' + dzMarkHTML();
  }

  function profileLink(m) {
    const prof = S.posts.filter(function (p) {
      return p.type === 'profile' && p.maker_ids.indexOf(m.id) >= 0;
    })[0];
    if (!prof) return '';
    return '<p class="dz-profile"><a class="u u-gray" href="' + postHref(prof) + '">' + esc(prof.title) + '\u00a0\u2192</a></p>';
  }

/* wiring: ports as-is */


  /* the one place the page moves without the reader, a deliberate exception; it
     stops for good at the first touch and runs only on screen and uncovered */
  function nudgeRegister(el, items) {
    if (!items.length || REDUCE || param('shot')) return;
    let i = 0, timer = null, live = false;

    function beat() {
      if (!live) return;
      /* a nudge beyond the window's edge is a beat of silence */
      let row = null;
      for (let t = 0; t < items.length; t++) {
        const cand = items[(i + t) % items.length];
        const b = cand.getBoundingClientRect();
        if (b.right > 0 && b.left < window.innerWidth && b.bottom > 0 && b.top < window.innerHeight) {
          row = cand; i = (i + t) % items.length;
          break;
        }
      }
      if (!row) { timer = setTimeout(beat, 5200); return; }
      row.classList.add('nudge');
      setTimeout(function () { row.classList.remove('nudge'); }, 2400);
      i++;
      timer = setTimeout(beat, 5200);
    }
    /* on screen the observer sees; under the footer's sheet only the footer
       knows (wireRiseFx), and without that the nudge goes on talking to the cover */
    let onScreen = false, clear = true, spent = false;
    function settle() {
      const want = onScreen && clear && !spent;
      if (want === live) return;
      live = want;
      clearTimeout(timer);
      if (live) timer = setTimeout(beat, 1200);
      else items.forEach(function (o) { o.classList.remove('nudge'); });
    }
    function stop() { spent = true; settle(); }
    dzNudgeNow = function (show) { clear = !!show; settle(); };
    /* pointermove, not pointerenter: scrolling slides the surface under a resting
       cursor and enter fires without the reader having done anything */
    el.addEventListener('pointermove', stop, { once: true });
    el.addEventListener('click', stop, { once: true });

    const seen = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { onScreen = e.isIntersecting; settle(); });
    }, { threshold: 0.4 });
    seen.observe(el);
  }

  /* the shared field: distance sets how far a row withdraws and when */
  function wireDzField(el, onAttend) {
    const items = el.querySelectorAll('.dz-item');
    let timer = null;

    function attend(i, wait) {
      el.dataset.attending = '';
      items.forEach(function (o, j) {
        o.style.setProperty('--d', Math.abs(i - j));
        o.classList.toggle('at', i === j);
      });
      if (!onAttend) return;
      clearTimeout(timer);
      /* long enough to ignore a passing pointer, short enough that a hand which
         meant to stop is answered at once */
      if (wait) timer = setTimeout(function () { onAttend(i); }, 120);
      else onAttend(i);
    }

    /* only a hovering pointer is attended: a tap quiets the list for the length
       of the press and lets go, which reads as a flicker */
    items.forEach(function (item, i) {
      item.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'touch') attend(i, true); });
    });
    nudgeRegister(el, items);
    el.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch') return;
      delete el.dataset.attending;
      items.forEach(function (o) { o.classList.remove('at'); });
      if (onAttend) { clearTimeout(timer); onAttend(-1); }
    });
  }
